const STORAGE_KEY_VERSION = "v1";

const dismissedInSession = new Set<string>();

export const buildFirstWorkCompleteDialogStorageKey = (
  workerId: string,
): string => `${STORAGE_KEY_VERSION}:firstWorkCompleteDialog:${workerId}`;

export function isFirstWorkCompleteDialogSeen(
  workerId: string | undefined,
): boolean {
  if (!workerId) return true;
  if (dismissedInSession.has(workerId)) return true;
  if (typeof window === "undefined") return true;

  try {
    return (
      localStorage.getItem(buildFirstWorkCompleteDialogStorageKey(workerId)) ===
      "true"
    );
  } catch {
    return dismissedInSession.has(workerId);
  }
}

/**
 * 初回勤務完了ダイアログ（継続勤務特典のお知らせ）を出すか。
 *
 * 2026-11 からの全特典廃止で継続勤務特典の訴求をやめたため、常に false を返す。
 * 呼び出し側は「表示しなかった」ときの経路（獲得報酬への遷移・レビュー依頼の判定）をそのまま通る。
 */
export function shouldShowFirstWorkCompleteDialog(_params: {
  isFirstWorkCompleted: boolean;
  workerId: string | undefined;
}): boolean {
  return false;
}

export function markFirstWorkCompleteDialogSeen(
  workerId: string | undefined,
): void {
  if (!workerId) return;

  dismissedInSession.add(workerId);

  try {
    localStorage.setItem(
      buildFirstWorkCompleteDialogStorageKey(workerId),
      "true",
    );
  } catch (error) {
    console.warn("Failed to write to localStorage:", error);
  }
}
